<div class="d-flex">
	<div class="h3 m-2">FocusLink Connector</div>

	<div class="d-flex my-2 ms-auto"></div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="card m-2 h-100">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Connector Info</div>
			</div>
			<p-divider></p-divider>
			<div class="p-grid">
				<div class="p-col">Connector License</div>
				<div class="p-col">
					<fa-icon *ngIf="venueService.subscriptionVenue.value.connectorLicense" [icon]="['far', 'check']" class="green-icon" size="2x"></fa-icon>
					<fa-icon *ngIf="!venueService.subscriptionVenue.value.connectorLicense" [icon]="['far', 'times']" class="red-icon" size="2x"></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Connector Claimed</div>
				<div class="p-col">
					<fa-icon *ngIf="venueService.subscriptionVenue.value.connectorClaimed" [icon]="['far', 'check']" class="green-icon" size="2x"></fa-icon>
					<fa-icon *ngIf="!venueService.subscriptionVenue.value.connectorClaimed" [icon]="['far', 'times']" class="red-icon" size="2x"></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Connector Status</div>
				<div class="p-col">
					<fa-icon
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
						*ngIf="app.moment().diff(app.moment(venueService.subscriptionVenue.value.status?.connectorHeartbeat), 'minutes') <= 10"
					></fa-icon>
					<fa-icon
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
						*ngIf="app.moment().diff(app.moment(venueService.subscriptionVenue.value.status?.connectorHeartbeat), 'minutes') > 10"
					></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Connector Version</div>
				<div class="p-col">
					{{ venueService.subscriptionVenue.value.connectorVersion }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Focus Version</div>
				<div class="p-col">
					{{ venueService.subscriptionVenue.value.VenuePos?.version }}
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Last Menu Sync</div>
				<div class="p-col">
					{{ app.moment(venueService.subscriptionVenue.value.status?.lastMenuSync).format("l LT") }}
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card m-2 h-100">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Store System Status</div>
			</div>
			<p-divider></p-divider>
			<div class="p-grid">
				<div class="p-col">Cloud Backup Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.backupService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon *ngIf="!venueService.subscriptionVenue.value.status?.backupService" [icon]="['far', 'times']" class="red-icon" size="2x"></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Config Sync Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.configurationService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon
						*ngIf="!venueService.subscriptionVenue.value.status?.configurationService"
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
					></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Datafeed Upload</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.datafeedService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon
						*ngIf="!venueService.subscriptionVenue.value.status?.datafeedService"
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
					></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Employee Messaging Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.employeeMessageService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon
						*ngIf="!venueService.subscriptionVenue.value.status?.employeeMessageService"
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
					></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Mobile Check Save Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.mobileCheckSaveService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon
						*ngIf="!venueService.subscriptionVenue.value.status?.mobileCheckSaveService"
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
					></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">Mobile API Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.mobileService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon *ngIf="!venueService.subscriptionVenue.value.status?.mobileService" [icon]="['far', 'times']" class="red-icon" size="2x"></fa-icon>
				</div>
			</div>
			<div class="p-grid">
				<div class="p-col">FocusKitchen Service</div>
				<div class="p-col">
					<fa-icon
						*ngIf="venueService.subscriptionVenue.value.status?.kitchenService"
						[icon]="['far', 'check']"
						class="green-icon"
						size="2x"
					></fa-icon>
					<fa-icon
						*ngIf="!venueService.subscriptionVenue.value.status?.kitchenService"
						[icon]="['far', 'times']"
						class="red-icon"
						size="2x"
					></fa-icon>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="card m-2">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Transaction Errors</div>
			</div>
			<p-divider></p-divider>
			<p-table
				#dt
				styleClass="p-datatable-responsive-demo"
				[value]="venueService.subscriptionVenue.value.status?.errors"
				[loading]="!venueService.subscriptionVenue.value.status?.errors"
				[globalFilterFields]="app.keys(venueService.subscriptionVenue.value.status?.errors)"
				[scrollable]="true"
				[rows]="100"
				scrollHeight="700px"
				[virtualScroll]="true"
				[virtualRowHeight]="40"
			>
				<ng-template pTemplate="caption">
					<div class="table-header d-flex">
						<div class="flex-grow-1">
							<span class="p-float-label p-input-icon-left m-2 w-100">
								<i class="pi pi-search"></i>
								<input
									pInputText
									class="w-100"
									id="globalSearch"
									name="globalSearch"
									style="width: 100%"
									type="text"
									(input)="dt.filterGlobal($event.target.value, 'contains')"
								/>
								<label for="globalSearch">Search...</label>
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="transactionDateTime">
							Date
							<p-sortIcon field="transactionDateTime"></p-sortIcon>
						</th>
						<th pSortableColumn="code">
							Error Type
							<p-sortIcon field="code"></p-sortIcon>
						</th>
						<th>Check</th>
					</tr>
				</ng-template>
				<ng-template let-rec pTemplate="body">
					<tr>
						<td>
							<span class="p-column-title">Date</span>
							{{ app.moment(rec.transactionDateTime).format("l LT") }}
						</td>
						<td>
							<span class="p-column-title">Error Type</span>
							{{ rec.code }}
						</td>
						<td>
							<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="onCheckSelect(rec.checkKey)">
								<ng-template pTemplate="content">
									<div class="d-flex justify-content-center">
										<fa-icon [icon]="['far', 'receipt']" size="lg" class="ms-1 me-2" size="lg"></fa-icon>
										View Check
									</div>
								</ng-template>
							</p-button>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card m-2">
			<div class="d-flex">
				<div class="h3 mx-4 mt-2 mb-1">Store Internet Connection</div>
			</div>
			<p-divider></p-divider>
			<p-table
				#dt
				styleClass="p-datatable-responsive-demo"
				[value]="venueInternetHistory"
				[loading]="!venueInternetHistory"
				[globalFilterFields]="app.keys(venueInternetHistory)"
				[scrollable]="true"
				[rows]="100"
				scrollHeight="700px"
				[virtualScroll]="true"
				[virtualRowHeight]="40"
			>
				<ng-template pTemplate="caption">
					<div class="table-header d-flex">
						<div class="flex-grow-1">
							<span class="p-float-label p-input-icon-left m-2 w-100">
								<i class="pi pi-search"></i>
								<input
									pInputText
									class="w-100"
									id="globalSearch"
									name="globalSearch"
									style="width: 100%"
									type="text"
									(input)="dt.filterGlobal($event.target.value, 'contains')"
								/>
								<label for="globalSearch">Search...</label>
							</span>
						</div>
						<div class="my-auto mx-2">
							<h4>Last 24 hours: {{ this.last24hrs }}</h4>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="disconnectDateTime">
							Incident
							<p-sortIcon field="disconnectDateTime"></p-sortIcon>
						</th>
						<th>Duration</th>
					</tr>
				</ng-template>
				<ng-template let-rec pTemplate="body">
					<tr>
						<td>
							<span class="p-column-title">Incident</span>
							{{ app.moment(rec.disconnectDateTime).format("lll") }}
						</td>
						<td>
							<span class="p-column-title">Duration</span>
							{{ app.moment(rec.disconnectDateTime).from(app.moment(rec.disconnectDateTime).add(rec.duration, "seconds"), true) }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-sidebar
	*ngIf="checkSelected"
	[(visible)]="checkSelected"
	position="right"
	appendTo="body"
	(onHide)="checkSelected = undefined"
	[showCloseIcon]="false"
	styleClass="p-sidebar-md"
>
	<app-check-record-viewer [incomingCheck]="checkSelected"></app-check-record-viewer>
</p-sidebar>
